import * as _ from "lodash";

import { Node } from "../Node";
import { AbstractProperty } from "./AbstractProperty";
import { assertNotNull } from "../../global";
import * as THREE from "three";

export class PThreeConstant extends AbstractProperty<string, Node> {
  default: string;
  selectOptions: string[];

  constructor(args) {
    super({
      type: "ThreeConstant",
      default: null,
      ...args,
    });
    assertNotNull("selectOptions", this.selectOptions);
  }

  typeCheck(value) {
    return _.isString(value);
  }

  toThree(instance) {
    instance[this.getNameThree()] = THREE[this.get()];
  }

  threeToInternalFormat(value: any): string {
    return this.selectOptions.find((k) => THREE[k] == value);
  }
}
